import { createStore } from 'vuex'

import { marketList, marketFavoriteList, marketFavoriteSave, userInfo } from '@/apis'
import wssId from '@/util/wssId'

import { message } from 'ant-design-vue'

export default createStore({
  state: {
    lang: 'en',
    webName: 'FTZINC',
    homeKey: [],
    market: {},
    marketInfo: {},
    ws: null,
    heartTimer: null,
    token: '',
    email: '',
    wsConnect: false,
    appShow: false,
    tabIndex: 0,
    isLight: Boolean(localStorage.getItem('isLight') == 'true'),

    ws1: null,
    heartTimer1: null,
    wsConnect1: false,

    marketCoinKey: [],
    marketCoin: {},
    marketContractKey: [],
    marketContract: {},

    marketCommoditiesKey: [],
    marketCommodities: {},

    marketIndicesKey: [],
    marketIndices: {},

    starKey: [],
    userInfo: {
      boxState: 0,
      gaSecret: false
    }
  },
  getters: {
    upList(state){
      let arr = []
      for(let key in state.market){
        arr.push({name: key, ...state.market[key]})
      }
      return arr.sort((a,b)=>{
        return b.growth - a.growth
      }).slice(0,9).map((item)=>{
        return item.name
      })
    },
    downList(state){
      let arr = []
      for(let key in state.market){
        arr.push({name: key, ...state.market[key]})
      }
      return arr.sort((a,b)=>{
        return a.growth - b.growth
      }).slice(0,9).map((item)=>{
        return item.name
      })
    }
  },
  mutations: {
    async getStar(state){
      const res = await marketFavoriteList({})
      if (res && res.code === 200 && res.data.length > 0) {
  
        for(let key in state.marketInfo){
          for(let i = 0;i < res.data.length;i++){
            if(state.marketInfo[key].id == res.data[i]){
              state.marketInfo[key].starShow = true
              state.starKey.push(state.marketInfo[key].coin)
            }
          }
        }
  
        state.starKey = Array.from(new Set(state.starKey))
      }
    },
    async addStar(state, {id, select}) {
      const res = await marketFavoriteSave({marketId: id, state: select})
      if (res.code === 200) {
        message.success(res.msg)

        const res1 = await marketFavoriteList({})
        if (res1 && res1.code === 200 && res1.data.length > 0) {
    
          for(let key in state.marketInfo){
            for(let i = 0;i < res1.data.length;i++){
              if(state.marketInfo[key].id == res1.data[i]){
                state.marketInfo[key].starShow = true
                state.starKey.push(state.marketInfo[key].coin)
              }
            }
          }
    
          state.starKey = Array.from(new Set(state.starKey))
        }
      }else{
        message.error(res.msg)
      }
  
      for(let key in state.marketInfo){
        if(state.marketInfo[key].id == id){
          state.marketInfo[key].starShow = select? true: false
  
          if(select == 0){
            state.starKey = state.starKey.filter((item) => item != key)
          }else{
            state.starKey.push(key)
          }
        }
      }
  
      state.starKey = Array.from(new Set(state.starKey))
  
    },
    appShowChange(state, appShow) {
      state.appShow = appShow
    },
    langChange(state, lang) {
      state.lang = lang
    },
    async wsInit(state) {
      if (state.heartTimer) clearInterval(state.heartTimer)
      try {
        if (state.ws) state.ws.close()
      } finally {
        // 
      }
      // 获取所有币种
      const res = await marketList()
      if (res && res.code === 200 && res.data.market.length > 0) {
        const list = res.data.market.map((item) => {
          const name = item.marketSymbol
          state.marketInfo[name] = {
            id: item.id, decimal: item.decimalNum, stock: item.marketName,
            name: item.marketName, coin: item.marketSymbol,
            icon: item.icon,starShow : false,
            maxAmount: item.maxAmount , minAmount: item.minAmount
          }
          state.market[name] = { deal: '0', high: '0', last: '0', low: '0', open: '0', up: true, volume: '0', growth: '0.00' }

          return name
        })
        state.homeKey = list.slice(0, 9)
        // state.homeKey.push('ERSUSDT')
        const wsLoad = () => {
          state.ws = new WebSocket(process.env.VUE_APP_WSS)
          state.ws.onopen = () => {
            state.wsConnect = true
            state.ws.send(JSON.stringify({ id: wssId['today.subscribe'], method: 'today.subscribe', params: list }))
            state.heartTimer = setInterval(() => {
              if (state.wsConnect && state.ws) {
                state.ws.send(1)
              }
            }, 10000)
          }
          state.ws.onmessage = (res) => {
            const data = JSON.parse(res.data)
            if (data.result) {
              const last = Number(data.result.last)
              const open = Number(data.result.open)
              let growth = '0.00'
              let up = true
              if (last > 0) { 
                growth = (Math.ceil((Math.abs(last - open) / open) * 10000) / 100).toFixed(2)
                if (Number(growth) === 100) {
                  growth = 99.99
                }

                if(open == 0){
                  growth = 0
                }
              }
              if (open > last) {
                growth = `-${ growth }`
                up = false
              } else {
                growth = `+${ growth }`
              }
              data.result['growth'] = growth
              data.result['up'] = up
              state.market[data.result.symbol] = data.result
            }
          }
          state.ws.onclose = () => {
            clearInterval(state.heartTimer)
            state.heartTimer = null
            state.ws = null
            state.wsConnect = false
            setTimeout(() => {
              wsLoad()
            }, 5000)
          } 
        }
        const wsLoad1 = () => {
          state.ws1 = new WebSocket(process.env.VUE_APP_WSS1)
          state.ws1.onopen = () => {
            state.wsConnect1 = true
            state.ws1.send(JSON.stringify({ id: wssId['today.subscribe'], method: 'today.subscribe', params: list, v: 1 }))
            state.heartTimer1 = setInterval(() => {
              if (state.wsConnect1 && state.ws1) {
                state.ws1.send(1)
              }
            }, 10000)
          }
          state.ws1.onmessage = (res) => {
            const data = JSON.parse(res.data)
            if (data.result) {
              const last = Number(data.result.last)
              const open = Number(data.result.open)
              let growth = '0.00'
              let up = true
              if (last > 0) { 
                growth = (Math.ceil((Math.abs(last - open) / open) * 10000) / 100).toFixed(2)
                if (Number(growth) === 100) {
                  growth = 99.99
                }

                if(open == 0){
                  growth = 0
                }
              }
              if (open > last) {
                growth = `-${ growth }`
                up = false
              } else {
                growth = `+${ growth }`
              }
              data.result['growth'] = growth
              data.result['up'] = up
              state.market[data.result.symbol] = data.result
            }
          }
          state.ws1.onclose = () => {
            clearInterval(state.heartTimer1)
            state.heartTimer1 = null
            state.ws1 = null
            state.wsConnect1 = false
            setTimeout(() => {
              wsLoad1()
            }, 5000)
          } 
        }
        wsLoad()
        wsLoad1()
      }

      const res1 = await marketList({type: 1})
      if (res1 && res1.code === 200 && res1.data.market.length > 0) {
        const list = res1.data.market.map(item => {
          const name = item.marketSymbol
          state.marketCoin[name] = {
            id: item.id, decimal: item.decimalNum, stock: item.marketName,
            name: item.marketName, coin: item.marketSymbol,starShow : false,
            icon: item.icon
          }
          return name
        })
        state.marketCoinKey = list
      }

      const res2 = await marketList({type: 2})
      if (res2 && res2.code === 200 && res2.data.market.length > 0) {
        const list = res2.data.market.map(item => {
          const name = item.marketSymbol

          if(!item.marketSymbol.endsWith('.GB')){
            state.marketContract[name] = {
              id: item.id, decimal: item.decimalNum, stock: item.marketName,
              name: item.marketName, coin: item.marketSymbol,starShow : false,
              icon: item.icon
            }
          }
            
          return name
        })
        state.marketContractKey = list.filter((item)=>{
          return !item.endsWith('.GB')
        })
      }


      
      const res3 = await marketList({type: 3})
      if (res3 && res3.code === 200 && res3.data.market.length > 0) {
        const list = res3.data.market.map(item => {
          const name = item.marketSymbol
          state.marketCommodities[name] = {
            id: item.id, decimal: item.decimalNum, stock: item.marketName,
            name: item.marketName, coin: item.marketSymbol,starShow : false,
            icon: item.icon
          }
          return name
        })
        state.marketCommoditiesKey = list
      }


      const res5 = await marketList({type: 4})
      if (res5 && res5.code === 200 && res5.data.market.length > 0) {
        const list = res5.data.market.map(item => {
          const name = item.marketSymbol
          state.marketIndices[name] = {
            id: item.id, decimal: item.decimalNum, stock: item.marketName,
            name: item.marketName, coin: item.marketSymbol,starShow : false,
            icon: item.icon
          }
          return name
        })
        state.marketIndicesKey = list
      }

      const res4 = await marketFavoriteList({})
      if (res4 && res4.code === 200 && res4.data.length > 0) {
  
        for(let key in state.marketInfo){
          for(let i = 0;i < res4.data.length;i++){
            if(state.marketInfo[key].id == res4.data[i]){
              state.marketInfo[key].starShow = true
              state.starKey.push(state.marketInfo[key].coin)
            }
          }
        }
  
        state.starKey = Array.from(new Set(state.starKey))
      }


    },
    tokenChange(state, token) {
      state.token = token
    },
    emailChange(state, email) {
      state.email = email
    },
    userInfoChange (state, data) {
      state.userInfo = data
    },
  },
  actions: {
    async refreshUserInfo ({ commit }) {
      const res = await userInfo()
      if (res.code === 200 && res.data) {
        commit('userInfoChange', res.data)
      }
      return res
    }
  },
  modules: {
  }
})
